'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _toLower = require('lodash/toLower');

var _toLower2 = _interopRequireDefault(_toLower);

var _split3 = require('lodash/split');

var _split4 = _interopRequireDefault(_split3);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _avatar = require('../avatar');

var _avatar2 = _interopRequireDefault(_avatar);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /** Text to display in the header */
  header: _propTypes2.default.node,
  /** The list of commands. Must be an array of objects containing the following:
  *
  * {
  *   value: String,
  *   prefix: String,
  *   description: Node (optional),
  *   param: Node (optional),
  *   avatar: Node (optional)
  * }
  */
  commands: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    /** The command's value */
    value: _propTypes2.default.string.isRequired,
    /** The command's prefix */
    prefix: _propTypes2.default.string.isRequired,
    /** Optional command description */
    description: _propTypes2.default.node,
    /** Optional command parameter */
    param: _propTypes2.default.node,
    /** Optional command avatar */
    avatar: _propTypes2.default.node
  })).isRequired,
  /** Filter commands based on input value */
  value: _propTypes2.default.string.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the title element */
  titleStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the description element */
  descriptionStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the command element */
  commandStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the param element */
  paramStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when a command is clicked
   *
   * function(event: object, command: string) => void
   */
  onSelect: _propTypes2.default.func.isRequired,
  /**
   * Callback fired when a command is moused over
   *
   * function(event: object, command: string) => void
   */
  onChange: _propTypes2.default.func.isRequired,
  /** Match first word or entire input */
  leading: _propTypes2.default.bool,
  /**
   * Callback fired when the menu is opened
   *
   * function() => void
   */
  onMenuOpen: _propTypes2.default.func,
  /**
   * Callback fired when the menu is closed
   *
   * function() => void
   */
  onMenuClose: _propTypes2.default.func,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  header: 'Commands',
  style: {},
  headerStyle: {},
  titleStyle: {},
  descriptionStyle: {},
  paramStyle: {},
  leading: true,
  commandStyle: {},
  onMenuOpen: _noop2.default,
  onMenuClose: _noop2.default
};

/** Used for displaying a list of commands */

var Commands = function (_Component) {
  _inherits(Commands, _Component);

  function Commands(props) {
    _classCallCheck(this, Commands);

    var _this = _possibleConstructorReturn(this, (Commands.__proto__ || Object.getPrototypeOf(Commands)).call(this, props));

    _this.filterCommands = function (commands, value) {
      var leading = _this.props.leading;


      if (leading) {
        return (0, _filter2.default)(commands, function (command) {
          var argument = '' + command.prefix + command.value;

          return (0, _startsWith2.default)((0, _toLower2.default)(argument), (0, _toLower2.default)(value));
        });
      }

      return (0, _filter2.default)(commands, function (command) {
        var _split = (0, _split4.default)(value, command.prefix),
            _split2 = _slicedToArray(_split, 1),
            argument = _split2[0];

        return (0, _startsWith2.default)(command.value, argument);
      });
    };

    _this.hideMenu = function () {
      var _this$props = _this.props,
          commands = _this$props.commands,
          onMenuClose = _this$props.onMenuClose;
      var open = _this.state.open;


      if (open) {
        _this.setState({
          open: false,
          commands: commands,
          selectedIndex: 0
        });
        onMenuClose();
      }
    };

    _this.handleClickOutside = function () {
      return _this.hideMenu();
    };

    _this.handleKeyDown = function (event) {
      var key = event.which || event.keyCode;
      var shiftKey = event.shiftKey;
      var _this$state = _this.state,
          selectedIndex = _this$state.selectedIndex,
          commands = _this$state.commands;


      if (key === 27) {
        return _this.hideMenu();
      }

      if (key === 39 || key === 40 || key === 9 && !shiftKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return _this.selectNext(event);
      }

      if (key === 37 || key === 38 || key === 9 && shiftKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return _this.selectPrevious(event);
      }

      if (key === 13) {
        event.preventDefault();
        event.stopImmediatePropagation();
        _this.handleSelect(event, commands[selectedIndex], selectedIndex);
      }

      return false;
    };

    _this.selectNext = function (event) {
      var _this$state2 = _this.state,
          selectedIndex = _this$state2.selectedIndex,
          commands = _this$state2.commands;

      var commandsSize = (0, _size2.default)(commands);

      if (selectedIndex + 1 < commandsSize) {
        return _this.handleChange(event, commands[selectedIndex + 1], selectedIndex + 1);
      }

      if (selectedIndex === commandsSize - 1) {
        return _this.handleChange(event, commands[0], 0);
      }

      return false;
    };

    _this.selectPrevious = function (event) {
      var _this$state3 = _this.state,
          selectedIndex = _this$state3.selectedIndex,
          commands = _this$state3.commands;

      var commandsSize = (0, _size2.default)(commands);

      if (selectedIndex === 0) {
        return _this.handleChange(event, commands[commandsSize - 1], commandsSize - 1);
      }

      if (selectedIndex - 1 < commandsSize) {
        return _this.handleChange(event, commands[selectedIndex - 1], selectedIndex - 1);
      }

      return false;
    };

    _this.handleSelect = function (event, command, index) {
      var onSelect = _this.props.onSelect;


      _this.setState({ selectedIndex: index });
      onSelect(event, '' + command.prefix + command.value);
    };

    _this.handleChange = function (event, command, index) {
      var onChange = _this.props.onChange;


      _this.setState({ selectedIndex: index });
      onChange(event, '' + command.prefix + command.value);
    };

    _this.state = {
      open: false,
      commands: _this.filterCommands(props.commands, props.value),
      selectedIndex: 0
    };
    return _this;
  }

  _createClass(Commands, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          commands = nextProps.commands;
      var open = this.state.open;
      var onMenuOpen = this.props.onMenuOpen;


      if (!value) {
        return this.hideMenu();
      }

      var filteredCommands = this.filterCommands(commands, value);

      if (!(0, _isEmpty2.default)(filteredCommands) && !open) {
        this.setState({
          open: true,
          commands: filteredCommands
        });

        return onMenuOpen();
      }

      if ((0, _isEmpty2.default)(filteredCommands) && open) {
        return this.hideMenu();
      }

      return this.setState({
        commands: filteredCommands
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          header = _props.header,
          commands = _props.commands,
          value = _props.value,
          color = _props.color,
          onChange = _props.onChange,
          onSelect = _props.onSelect,
          style = _props.style,
          headerStyle = _props.headerStyle,
          titleStyle = _props.titleStyle,
          descriptionStyle = _props.descriptionStyle,
          paramStyle = _props.paramStyle,
          eventTypes = _props.eventTypes,
          outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
          preventDefault = _props.preventDefault,
          stopPropagation = _props.stopPropagation,
          disableOnClickOutside = _props.disableOnClickOutside,
          enableOnClickOutside = _props.enableOnClickOutside,
          leading = _props.leading,
          onMenuOpen = _props.onMenuOpen,
          onMenuClose = _props.onMenuClose,
          commandStyle = _props.commandStyle,
          custom = _objectWithoutProperties(_props, ['header', 'commands', 'value', 'color', 'onChange', 'onSelect', 'style', 'headerStyle', 'titleStyle', 'descriptionStyle', 'paramStyle', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation', 'disableOnClickOutside', 'enableOnClickOutside', 'leading', 'onMenuOpen', 'onMenuClose', 'commandStyle']);

      var _state = this.state,
          open = _state.open,
          selectedIndex = _state.selectedIndex;


      if (!open) {
        return null;
      }

      return _react2.default.createElement(
        'section',
        _extends({ style: _getStyles2.default.root(style) }, custom),
        _react2.default.createElement(
          'header',
          { style: _getStyles2.default.header(headerStyle) },
          header
        ),
        _react2.default.createElement(
          'section',
          { style: _getStyles2.default.commands() },
          (0, _map2.default)(this.state.commands, function (command, index) {
            return (// eslint-disable-line react/destructuring-assignment
              _react2.default.createElement(
                'div',
                {
                  key: command.value,
                  style: _getStyles2.default.command(color, index === selectedIndex, commandStyle),
                  onClick: function onClick(event) {
                    return _this2.handleSelect(event, command, index);
                  },
                  onMouseOver: function onMouseOver(event) {
                    return _this2.handleChange(event, command, index);
                  }
                },
                _react2.default.createElement(
                  'span',
                  { style: _styles2.default.titleContainer },
                  command.avatar ? _react2.default.createElement(
                    'div',
                    { style: _styles2.default.avatarContainer },
                    (0, _isString2.default)(command.avatar) ? _react2.default.createElement(_avatar2.default, { image: command.avatar, style: _styles2.default.avatar }) : command.avatar
                  ) : null,
                  _react2.default.createElement(
                    'strong',
                    { style: _getStyles2.default.title(titleStyle) },
                    command.prefix,
                    command.value
                  ),
                  command.param ? _react2.default.createElement(
                    'span',
                    { style: paramStyle },
                    '[',
                    command.param,
                    ']'
                  ) : null
                ),
                command.description ? _react2.default.createElement(
                  'span',
                  { style: _getStyles2.default.description(descriptionStyle) },
                  command.description
                ) : null
              )
            );
          })
        ),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyDown: this.handleKeyDown })
      );
    }
  }]);

  return Commands;
}(_react.Component);

Commands.displayName = 'Commands';
Commands.propTypes = propTypes;
Commands.defaultProps = defaultProps;

exports.default = Commands;
module.exports = exports.default;